import React from 'react';
import styled from 'styled-components';
import { SubMenu } from '../../../components/admin/navigation/SubMenu';
import { Route, useRouteMatch, Redirect, Switch } from 'react-router-dom';
import { Main } from '../../../components/main/Main';

export const AdminTemplates = ({ route, deepRoute, setDeepRoute }) => {
  const { path } = useRouteMatch();
  return (
    <Container>
      {route && route.hasSubMenu && <SubMenu route={route} />}

      <Switch>
        {deepRoute ? (
          <Route path={`${path}/:child/:slug`}>
            <Main route={route} />
          </Route>
        ) : (
          <Route path={`${path}/:child`}>
            <Main route={route} />
          </Route>
        )}
        {setDeepRoute(false)}
        <Redirect from='/admin/templates' to='/admin/templates/view-all' />
      </Switch>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  background: ${(props) => props.theme.color.bgGrey};
`;
